module.exports = __webpack_public_path__ + "ls.svg?70f84325b9d88b9e3476338919627e91";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ls.svg
// module id = 1058
// module chunks = 27